export class RemoveConditionalsRequest {
  constructor(
    public questionId: string,
    public questionIdsToRemoveOnConditions: string[],
    public optionId: string = null,
    public cardId: string = null
  ) {}
}
